import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header, MobileNav, Footer } from "@/components/Layout";
import { RequireAuth } from "@/components/common";
import Home from "@/pages/Home";
import Discover from "@/pages/Discover";
import EventDetail from "@/pages/EventDetail";
import Creators from "@/pages/Creators";
import CreatorProfile from "@/pages/CreatorProfile";
import Leaderboard from "@/pages/Leaderboard";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import Tickets from "@/pages/Tickets";
import Profile from "@/pages/Profile";
import EventForm from "@/pages/EventForm";
import MyEvents from "@/pages/MyEvents";
import ManageEvent from "@/pages/ManageEvent";
import Notifications from "@/pages/Notifications";
import PaymentStatus from "@/pages/PaymentStatus";
import NotFound from "@/pages/NotFound";
import { PrivacyPage, TermsPage, SmsPage } from "@/pages/Legal";
import { DeleteAccountPage, AccountDeletedPage } from "@/pages/DeleteAccount";

const Fallback = () => {
  const loc = useLocation();
  return new URLSearchParams(loc.search).get("session_id") ? <PaymentStatus /> : <NotFound />;
};

const guard = (el) => <RequireAuth>{el}</RequireAuth>;

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Discover />} />
            <Route path="/events/new" element={guard(<EventForm />)} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/e/:id" element={<EventDetail />} />
            <Route path="/events/:id/edit" element={guard(<EventForm />)} />
            <Route path="/creators" element={guard(<Creators />)} />
            <Route path="/creators/:id" element={guard(<CreatorProfile />)} />
            <Route path="/leaderboard" element={guard(<Leaderboard />)} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/tickets" element={guard(<Tickets />)} />
            <Route path="/profile" element={guard(<Profile />)} />
            <Route path="/manage" element={guard(<MyEvents />)} />
            <Route path="/manage/:id" element={guard(<ManageEvent />)} />
            <Route path="/notifications" element={guard(<Notifications />)} />
            <Route path="/payment-success" element={<PaymentStatus />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/sms" element={<SmsPage />} />
            <Route path="/account/delete" element={guard(<DeleteAccountPage />)} />
            <Route path="/account/deleted" element={<AccountDeletedPage />} />
            <Route path="*" element={<Fallback />} />
          </Routes>
          <Footer />
          <MobileNav />
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
